

export const INIT_HOME = '@@home/INIT_HOME'
export const homeInit = () => ({
    displayName: 'initialise home',
    type: INIT_HOME
})

export const UPDATE_DASHBOARD = '@@home/UPDATE_DASHBOARD'
export const updateDashboard = ( dashboard ) => ({
    displayName: 'update dashboard',
    type: UPDATE_DASHBOARD,
    dashboard: dashboard,
})

export const QUIT_HOME = '@@home/QUIT_HOME'
export const homeQuit = () => ({
    displayName: 'quit home',
    type: QUIT_HOME,
})




// WEBPACK FOOTER //
// ./src/App/Admin/Home/actions.js